// extracted by mini-css-extract-plugin
export var chevron = "_lv-2";
export var chevronRotated = "_lv-3";
export var header = "_lv-1";
export var section = "_lv-0";